import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { tap } from 'rxjs/operators';

export interface UserProfile {
  role: {
    name: string;
    description: string;
    id: number;
  };
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  isActive: boolean;
  lastLogin: string;
  roleName: string | null;
  id: number;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly API_URL = `${environment.apiUrl}/v1/User/me`;
  private readonly STORAGE_KEY = 'currentUser';

  constructor(private http: HttpClient) { }

  getProfile(): Observable<UserProfile> {
    const storedProfile = localStorage.getItem(this.STORAGE_KEY);
    if (storedProfile) {
      return of(JSON.parse(storedProfile));
    }

    return this.http.get<UserProfile>(this.API_URL).pipe(
      tap((profile) => {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(profile));
      }),
    );
  }

  clearProfile(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
